const STORAGE_KEY = 'web1_analytics_consent_v1';

const readChoice = () => {
    try {
        return window.localStorage.getItem(STORAGE_KEY);
    } catch (error) {
        return null;
    }
};

const saveChoice = (choice) => {
    try {
        window.localStorage.setItem(STORAGE_KEY, choice);
    } catch (error) {
        // Brak dostępu do localStorage nie może blokować korzystania ze strony.
    }
};

const loadGoogleAnalytics = (measurementId) => {
    if (!measurementId || document.querySelector('[data-google-analytics-script]')) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
    });
    window.gtag('consent', 'update', {
        analytics_storage: 'granted',
    });
    window.gtag('js', new Date());
    window.gtag('config', measurementId, {anonymize_ip: true});

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(measurementId)}`;
    script.dataset.googleAnalyticsScript = 'true';
    document.head.append(script);
};

const disableGoogleAnalytics = () => {
    if (typeof window.gtag === 'function') {
        window.gtag('consent', 'update', {
            ad_storage: 'denied',
            ad_user_data: 'denied',
            ad_personalization: 'denied',
            analytics_storage: 'denied',
        });
    }

    const cookieNames = document.cookie
        .split(';')
        .map((cookie) => cookie.split('=')[0].trim())
        .filter((name) => name === '_ga' || name.startsWith('_ga_'));
    const hostnameParts = window.location.hostname.split('.');
    const domainCandidates = new Set(['']);

    for (let index = 0; index < hostnameParts.length - 1; index += 1) {
        const domain = hostnameParts.slice(index).join('.');
        domainCandidates.add(domain);
        domainCandidates.add(`.${domain}`);
    }

    cookieNames.forEach((name) => {
        domainCandidates.forEach((domain) => {
            const domainAttribute = domain ? `; domain=${domain}` : '';
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/${domainAttribute}; SameSite=Lax`;
        });
    });
};

export function initCookieConsent() {
    const panel = document.querySelector('[data-cookie-consent]');
    if (!panel) {
        return;
    }

    const acceptButton = panel.querySelector('[data-cookie-accept]');
    const rejectButton = panel.querySelector('[data-cookie-reject]');
    const settingsButtons = document.querySelectorAll('[data-cookie-settings]');
    const status = panel.querySelector('[data-cookie-consent-status]');
    const analyticsEnabled = panel.dataset.analyticsEnabled === 'true';
    const measurementId = panel.dataset.googleAnalyticsId || '';

    const hidePanel = () => {
        panel.hidden = true;
    };

    const showPanel = () => {
        panel.hidden = false;
        rejectButton?.focus();
    };

    const setChoice = (choice) => {
        saveChoice(choice);
        if (choice === 'granted' && analyticsEnabled) {
            loadGoogleAnalytics(measurementId);
            if (status) {
                status.textContent = 'Analityka została zaakceptowana.';
            }
        } else {
            disableGoogleAnalytics();
            if (status) {
                status.textContent = 'Analityka została odrzucona.';
            }
        }
        hidePanel();
    };

    acceptButton?.addEventListener('click', () => setChoice('granted'));
    rejectButton?.addEventListener('click', () => setChoice('denied'));
    settingsButtons.forEach((button) => button.addEventListener('click', showPanel));

    const savedChoice = readChoice();
    if (savedChoice === 'granted') {
        if (analyticsEnabled) {
            loadGoogleAnalytics(measurementId);
        }
        return;
    }
    if (savedChoice === 'denied') {
        return;
    }
    showPanel();
}
